import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import {
  FaMobileAlt,
  FaCheckCircle,
  FaMoneyBillWave,
  FaLock,
  FaFileAlt,
  FaClock,
} from 'react-icons/fa';

import './how-it-works.css';

const steps = [
  {
    icon: <FaMobileAlt />,
    title: 'Apply Online',
    desc: 'Complete your application swiftly and securely from your phone—fully paperless and hassle-free.',
  },
  {
    icon: <FaCheckCircle />,
    title: 'Instant Approval',
    desc: 'Get your application approved within minutes—fast, reliable, and seamless.',
  },
  {
    icon: <FaMoneyBillWave />,
    title: 'Receive Your Money',
    desc: 'Upon approval, funds are efficiently and securely deposited directly into your bank account.',
  },
  {
    icon: <FaFileAlt />,
    title: 'Minimal Documentation',
    desc: 'Only essential paperwork—clear, straightforward, and easy to complete.',
  },
  {
    icon: <FaLock />,
    title: 'Secure Process',
    desc: 'Your data is protected with advanced encryption protocols, ensuring complete privacy and confidentiality.',
  },
  {
    icon: <FaClock />,
    title: '24/7 Service',
    desc: 'Apply anytime, anywhere — we’re always available.',
  },
];

const HowItWorks = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section id="how-it-works" className="how-works-vertical py-3">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="how-title">HOW IT WORKS</h2>
          <p className="how-subtext text-light">
           Effortless. Transparent. Swift. Hassle-free.
          </p>
        </div>

        <div className="timeline-grid">
          {/* Left Column */}
          <div className="timeline-col">
            {steps.slice(0, 3).map((step, index) => (
              <div
                className="timeline-item"
                key={index}
                data-aos="fade-right"
              >
                <div className="timeline-icon">{step.icon}</div>
                <div className="timeline-content">
                  <h5>{step.title}</h5>
                  <p>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Center Divider */}
          <div className="timeline-divider-wrapper">
            <div className="timeline-divider-line"></div>
          </div>

          {/* Right Column */}
          <div className="timeline-col">
            {steps.slice(3).map((step, index) => (
              <div
                className="timeline-item"
                key={index + 3}
                data-aos="fade-left"
              >
                <div className="timeline-icon">{step.icon}</div>
                <div className="timeline-content">
                  <h5>{step.title}</h5>
                  <p>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
